
import { defineComponent } from "vue";
import Nav from "@/components/base-page/Nav.vue";
import Header from "@/components/base-page/Header.vue";

export default defineComponent({
  name: "Layout",
  components: { Header, Nav },
});
